import { Component } from '@angular/core';

@Component({
    selector: 'app-presentation',
    templateUrl: './presentation.component.html',
    styleUrls: ['./presentation.component.css'],
    standalone: false
})
export class PresentationComponent {

  constructor() { }


}
